export default {
    init () {
        let media1 = document.getElementById('video1');
        let media2 = document.getElementById('video2');
        let media3 = document.getElementById('video3');


        $('.video1').click(function () {
            media1.pause()
            $('.video1 .video-play').css({"display":'block'})
        })
        $('.video1 .video-play').click(function (event) {
            media1.play()
            $('.video1 .video-play').css({"display":'none'})

            media2.pause()
            $('.video2 .video-play').css({"display":'block'})
            media3.pause()
            $('.video3 .video-play').css({"display":'block'})

            event.stopPropagation();
        });

        $('.video2').click(function () {
            media2.pause()
            $('.video2 .video-play').css({"display":'block'})
        })
        $('.video2 .video-play').click(function (event) {
            media2.play()
            $('.video2 .video-play').css({"display":'none'})

            media1.pause()
            $('.video1 .video-play').css({"display":'block'})
            media3.pause()
            $('.video3 .video-play').css({"display":'block'})
            event.stopPropagation();
        });

        $('.video3').click(function () {
            media3.pause()
            $('.video3 .video-play').css({"display":'block'})
        })
        $('.video3 .video-play').click(function (event) {
            media3.play()
            $('.video3 .video-play').css({"display":'none'})

            media1.pause()
            $('.video1 .video-play').css({"display":'block'})
            media2.pause()
            $('.video2 .video-play').css({"display":'block'})
            event.stopPropagation();
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/finance/video.js